<div class="pdf-render-content">
  <div class="header-logo-row">
    <div class="header-img">
      <img [attr.src]="rightLogo()" class="client_logo"/>

    </div>
    <div class="title-row">
      <h1>{{ pdfHeader }}</h1>
      @if (dateInst.dtp) {
        <div class="print-header-dtp">Production period: from
          <b>{{ dateInst.dtp.start | stringDate : {date_only: true} }}</b>
          at <b>{{ dateInst.dtp.start | date : 'HH:mm' }}</b>
          to <b>{{ dateInst.dtp.end | stringDate : {date_only: true} }}</b>
          at <b>{{ dateInst.dtp.end | date : 'HH:mm' }}</b>
        </div>
      }
    </div>
    <div class="header-img">
      <img src="/static/images/wire-logo-black.png"/>
    </div>
  </div>

</div>
